import * as React from 'react';
import { useDispatch } from 'react-redux';

import { trackCommentEdit } from './trackings';
import { startEditNote } from '../../actions/favoriteEntities/notes';
import { EditButton } from '../../components/EditButton/EditButton';

interface IEditCommentButtonContainerProps {
  entityId: number;
}

export const EditCommentButtonContainer = ({ entityId }: IEditCommentButtonContainerProps) => {
  const dispatch = useDispatch();

  const handleClick = React.useCallback(() => {
    dispatch(startEditNote(entityId));

    trackCommentEdit();
  }, [dispatch, entityId]);

  return <EditButton onClick={handleClick} entityId={entityId} />;
};
